import { SingularityMetaV } from "@/types/document";
import * as t from "io-ts";

export const PageInWPV = t.type({
  id: t.number,
  title: t.string,
  relativeUrl: t.string,
  postType: t.string,
  singularityMeta: SingularityMetaV
});

export type PageInWP = t.TypeOf<typeof PageInWPV>;
